export const PARAGRAPH = 1;
export const MULTIPLE = 2;